<template>
    <div style="background-color:white;height: 100%;width: 100%;">
        <el-row style="padding-top:10px">
            <el-col :span="24">
                <div style="float: right; margin-right: 30px">
                    <el-form :inline="true" ref="deviceInfo" :model="deviceInfo" class="demo-form-inline">
                        <el-form-item :label="lable.wbr">
                            <el-input v-model="deviceInfo.id" auto-complete="off" placeholder="请输入搜索内容"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="small" type="primary" @click="findAllClick">查询</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </el-col>
        </el-row>
        <el-table :data="userData" :border="true" style="width: 100%" ref="multipleTable"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }" :cell-style="{ textAlign: 'center' }">
            <el-table-column type="index" :label="lable.index" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="userId" :label="lable.userId">
            </el-table-column>
            <el-table-column prop="userName" :label="lable.wbr">
            </el-table-column>
            <el-table-column prop="tel" :label="lable.tel">
            </el-table-column>
            <el-table-column prop="wbsc" :label="lable.wbsc">
            </el-table-column>
            <el-table-column prop="wbpj" :label="lable.wbpj">
            </el-table-column>
            <el-table-column prop="wbcs" :label="lable.wbcs">
            </el-table-column>
            <el-table-column :label="lable.cz">
                <template slot-scope="scope">
                    <el-button @click="selectByid(scope.row)" type="text" size="small">查看维保记录</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-row>
            <!--分页工具条-->
            <el-col :span="24" class="toolbar" style="margin-top:5px;height: 35px;">
                <el-pagination v-if="userData.length > 0" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]" :page-size="pagesize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right">
                </el-pagination>
            </el-col>
        </el-row>
        <el-dialog :visible.sync="isShow" :close-on-click-modal="false" :close-on-press-escape="false" title="维保记录"
            style="width: 120% !important;right:100px;">
            <div style="float: right; margin-right: 30px">
                <el-form :inline="true" ref="deviceInfo" :model="deviceInfo" class="demo-form-inline">
                    <el-form-item>
                        <el-date-picker v-model="deviceInfo.date" value-format="yyyy-MM-dd" type="daterange"
                            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" type="primary">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <el-table :data="maintenanceData" :border="true" style="width: 100%" ref="multipleTable" max-height="450px"
                size="mini" :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
                :cell-style="{ textAlign: 'center' }">
                <el-table-column prop="id" :label="lable.id" width="150">
                    <template slot-scope="scope">
                        <el-link :underline="false" @click="selectClick(scope.row)"
                            style="color: #4095e5; text-decoration: none">
                            {{ scope.row.id }}
                        </el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="zcmc" :label="lable.zcmc">
                </el-table-column>
                <el-table-column prop="maintenanceType" label="维保类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.maintenanceType == '0'">设备维修</span>
                        <span v-else-if="scope.row.maintenanceType == '1'">设备保养</span>

                    </template>
                </el-table-column>
                <el-table-column prop="evaluate" :label="lable.evaluate">
                    <template slot-scope="scope">
                        <span v-if="scope.row.evaluate == '1'">非常差</span>
                        <span v-else-if="scope.row.evaluate == '2'">差</span>
                        <span v-else-if="scope.row.evaluate == '3'">一般</span>
                        <span v-else-if="scope.row.evaluate == '4'">好</span>
                        <span v-else-if="scope.row.evaluate == '5'">非常好</span>
                    </template>
                </el-table-column>
                <el-table-column prop="startTime" :label="lable.startTime">
                </el-table-column>
                <el-table-column prop="endTime" :label="lable.endTime">
                </el-table-column>
                <el-table-column prop="project" :label="lable.project">
                </el-table-column>
                <el-table-column prop="wz" :label="lable.statue">
                </el-table-column>
                <el-table-column :label="lable.cz">
                    <template slot-scope="scope">
                        <el-button @click="selectActivity(scope.row)" type="text" size="small">详情</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="id" v-if="false">
                </el-table-column>
            </el-table>
            <!------------------------------------------------------------------------维保详情弹框------------------------------------------------------->
            <el-dialog :visible.sync="dialogFormVisible2" title="维保详情" :close-on-click-modal="false"
                :close-on-press-escape="false" :append-to-body="true" style="width: 100% !important; margin-left: 5%">
                <el-form :model="questionForm" ref="dataForm" label-position="left" label-width="100px"
                    style="width: 90%; margin-left: 5%">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item :label="lable.id" style="width: 90%">
                                <el-input :readonly="true" v-model="questionForm.id" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="lable.zcmc">
                                <el-input :readonly="true" v-model="questionForm.zcmc" /> </el-form-item></el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item :label="lable.glbh" style="width: 90%">
                                <el-input :readonly="true" v-model="questionForm.glbh" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="lable.ssdw">
                                <el-input :readonly="true" v-model="questionForm.ssdw" /> </el-form-item></el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="维保类别" style="width: 90%">
                                <el-input v-if="questionForm.maintenanceType == '0'" :readonly="true" value="设备维修" />
                                <el-input v-else-if="questionForm.maintenanceType == '1'" :readonly="true" value="设备保养" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="lable.applyTime">
                                <el-input :readonly="true" v-model="questionForm.applyTime" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item :label="lable.userName" style="width: 90%">
                                <el-input :readonly="true" v-model="questionForm.userName" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="lable.companyName">
                                <el-input placeholder="" :readonly="true" v-model="questionForm.companyName" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item :label="lable.reason" style="width: 90%">
                                <el-input :readonly="true" v-model="questionForm.reason" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="lable.wbr">
                                <el-input placeholder="维保未审批" :readonly="true" v-model="questionForm.wbrxm" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item :label="lable.tel" style="width: 90%">
                                <el-input placeholder="维保未审批" :readonly="true" v-model="questionForm.personTel" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="lable.maintainMany">
                                <el-input placeholder="维保未开始" :readonly="true" v-model="questionForm.maintainMany" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item :label="lable.startTime" style="width: 90%">
                                <el-date-picker v-model="questionForm.startTime" style="width: 100%"
                                    value-format="yyyy-MM-dd" width="100%" :readonly="true" type="date" placeholder="维保未开始">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="lable.endTime">
                                <el-date-picker v-model="questionForm.endTime" style="width: 100%" value-format="yyyy-MM-dd"
                                    width="100%" :readonly="true" type="date" placeholder="维保未开始">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item :label="lable.equipment" style="width: 90%">
                                <el-input :readonly="true" placeholder="维保未开始" v-model="questionForm.equipment" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="lable.project">
                                <el-input :readonly="true" placeholder="维保未开始" v-model="questionForm.project" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="维保结果" style="width:90%">
                                <el-input :readonly="true" v-model="questionForm.result" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="需检定/校准">
                                <el-radio-group v-model="questionForm.isCheck" :disabled="true" style="width: 100%">
                                    <el-input :readonly="true" v-if="questionForm.isCheck == '0'" value="需要检定" />
                                    <el-input :readonly="true" v-else-if="questionForm.isCheck == '1'" value="不需要检定" />
                                    <el-input :readonly="true" v-if="(questionForm.isCheck != '0') &
                                        (questionForm.isCheck != '1')
                                        " placeholder="请选择管理项" value="维保未确认" />
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="维保记录">
                                <el-input :readonly="true" type="textarea" :rows="2" v-model="questionForm.wbjl" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item :label="lable.processReson">
                        <el-input type="textarea" :readonly="true" :rows="2" placeholder="请输入内容"
                            v-model="questionForm.processReson">
                        </el-input>
                    </el-form-item>
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane label="业务信息" name="first">
                            <el-table :data="tableData" :border="false"
                                style="width: 90%; margin-left: 20px; text-align: center" size="mini" :header-cell-style="{
                                    textAlign: 'center',
                                    background: '#eff3f6'
                                }" :cell-style="{ textAlign: 'center' }" max-height="200px">
                                <el-table-column label="序号" type="index" show-overflow-tooltip >
                                </el-table-column>
                                <el-table-column prop="createTime" label="时间" show-overflow-tooltip>
                                </el-table-column>
                                <el-table-column prop="nodeName" label="事件" show-overflow-tooltip>
                                </el-table-column>
                                <el-table-column prop="workflowResult" label="审批结果" show-overflow-tooltip>
                                </el-table-column>
                                <el-table-column prop="bz" label="审核意见" show-overflow-tooltip>
                                </el-table-column>
                                <el-table-column prop="ssdw" label="单位" show-overflow-tooltip>
                                </el-table-column>
                                <el-table-column prop="userId" label="操作人" show-overflow-tooltip>
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                        <el-tab-pane label="附加资料" name="second">
                            <el-table :data="fileData" :border="false"
                                style="width: 90%; margin-left: 20px; text-align: center" size="mini" :header-cell-style="{
                                    textAlign: 'center',
                                    background: '#eff3f6'
                                }" :cell-style="{ textAlign: 'center' }" max-height="200px">
                                <el-table-column label="序号" type="index"  show-overflow-tooltip>
                                </el-table-column>
                                <el-table-column label="id" v-if="false"> </el-table-column>
                                <el-table-column prop="name" label="资料名称" show-overflow-tooltip>
                                </el-table-column>
                                <el-table-column prop="createTime" label="上传日期" show-overflow-tooltip>
                                </el-table-column>
                                <el-table-column prop="fileDesc" label="备注" show-overflow-tooltip>
                                </el-table-column>
                                <el-table-column fixed="right" label="操作" width="150px">
                                    <template slot-scope="scope">
                                        <el-button @click="yulan(scope.row)" type="text" size="small">预览</el-button>
                                        <el-button type="text" size="small" @click="downloading(scope.row)">下载</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                    </el-tabs>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible2 = false" type="primary" v-preventReClick>确认</el-button>
                </div>
            </el-dialog>
        </el-dialog>
        <el-dialog :title="previewTitle" :visible.sync="docxdialog" style="margin-top:-50px" width="63%">
            <FilePreview ref="filePreview" />
        </el-dialog>

    </div>
</template>
<script>
import { selectMaintenanceUser, selectMaintenanceUserById, findByIdMaintenance, findByIdWorkflow, findByIdFile, findByModule } from "../../api/api";
import FilePreview from '../../components/preview/FilePreview.vue'

export default {
    name: "statistics",
    components: {
        "FilePreview": FilePreview,
    },
    data() {
        return {
            deviceInfo: {
                id: ""
            },
            lable: {},
            activeName: 'first',
            fileData: [],
            isShow: false,
            total: 0,
            pageIndex: 1,
            pagesize: 10,
            data: [],
            tableData: [
            ],
            docxdialog: false,
            previewTitle: '',
            userData: [],
            dialogFormVisible2: false,
            questionForm: {},
            maintenanceData: [
            ],
        };
    },
    methods: {
        yulan(row) {
            if (row.path.substring(row.path.lastIndexOf(".") + 1) == 'jpg' || row.path.substring(row.path.lastIndexOf(".") + 1) == 'png' || row.path.substring(row.path.lastIndexOf(".") + 1) == 'jpeg') {
                this.previewTitle = "图片预览"
            } else {
                this.previewTitle = "文件预览"
            }
            this.docxdialog = true
            this.$nextTick(() => {
                this.$refs.filePreview.showView(row.path)
            })
            // this.downloadUtil.preview(row.path)
        },
        findAllClick() {
            this.pageIndex = 1
            this.findAll()
        },
        downloading(scop) {
            // debugger
            this.downloadUtil.downloadFile(scop.path, scop.name);
        },
        //根据id查找文件
        findByIdfile(id) {
            findByIdFile(id).then(datas => {
                let { status, message, data } = datas;
                if (status == 200) {
                    this.fileData = [];
                    this.fileData = data;
                }
            });
        },
        handleClick(row) {
        },
        //根据id查找业务流程信息
        findByIdWork(row) {
            findByIdWorkflow(row).then(datas => {
                // debugger
                let { status, message, data } = datas;
                if (status == 200) {
                    this.tableData = [];
                    this.tableData = data;
                }
            });
        },
        findAll() {
            var userinfo = JSON.parse(localStorage.getItem("user"))
            let map = {
                id: this.deviceInfo.id,
                userId: userinfo.userId
            }
            selectMaintenanceUser(map).then(datas => {
                let { status, message, data } = datas;
                if (status == 200) {
                    if (data == null) { this.data = [] } else { this.data = data; }

                    this.userData = this.data.slice(
                        (this.pageIndex - 1) * this.pagesize,
                        this.pageIndex * this.pagesize
                    );
                    this.total = this.data.length;
                }
            });
        },
        selectActivity(row) {
            let _parameter = {
                id: row.id,
            }
            findByIdMaintenance(_parameter).then(datas => {
                let { status, message, data } = datas;
                if (status == 200) {
                    this.questionForm = data;
                    this.dialogFormVisible2 = true;
                    this.findByIdfile(row.id);
                    this.findByIdWork(row.id);
                }
            });
        },
        selectByid(row) {
            this.isShow = true;
            this.maintenanceData = []
            let permar = {
                id: row.userId
            }
            selectMaintenanceUserById(permar).then(datas => {
                let { status, message, data } = datas;
                if (status == 200) {
                    this.maintenanceData = data;
                }
            });
        },
        //分页
        handleCurrentChange(val) {
            this.pageIndex = val;
            //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
            //.slice()方法接受两个参数，开始和结束的值
            //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
            this.userData = this.data.slice(
                (this.pageIndex - 1) * this.pagesize,
                this.pageIndex * this.pagesize
            );
        },
        handleSizeChange(val) {
            this.pagesize = val;
            this.userData = this.data.slice(
                (this.pageIndex - 1) * this.pagesize,
                this.pageIndex * this.pagesize
            );
        },
        findLable() {
            findByModule("维保管理").then(datas => {
                let { status, message, data } = datas;
                if (status == 200) {
                    this.lable = data;
                }
            });
        },
    },
    created() {
        this.findLable();
        this.findAll();
    },
};
</script>
<style >
.el-checkbox__inner {
    border: 1px solid #606266 !important;
}
</style>
<style scoped></style>
  


// WEBPACK FOOTER //
// src/views/maintenance/statistics.vue